module.exports = __webpack_public_path__ + "static/media/cta.17c2751c.svg";